import {Fireworks} from 'fireworks/lib/react'
import React, {Component} from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";


export default class ExperienceBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            experienceValue: null,
            experiencePoints: null,
            dingTimer: null,
            stepTimer: null,

            brandValue: null,
            personalValue: null,
            inclusion: null,
            affinity: null,

            interval: 0,
        };
        this.ding = this.ding.bind(this);
        this.resetDingTimer = this.resetDingTimer.bind(this);
        this.step = this.step.bind(this);
        this.resetStepTimer = this.resetStepTimer.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (Object.keys(this.props.experience).length !== 0) {

            if (this.state.experienceValue) {
                if (this.props.experience.value !== this.state.experienceValue) {
                    this.setState({
                        experienceValue: this.props.experience.value,
                        experiencePoints: this.props.experience.points,
                    }, this.ding)
                } else {
                    if (this.props.experience.points !== this.state.experiencePoints) {
                        this.setState({
                            experienceValue: this.props.experience.value,
                            experiencePoints: this.props.experience.points,
                        }, this.step)
                    }
                }
            } else {
                this.setState({
                    experienceValue: this.props.experience.value,
                    experiencePoints: this.props.experience.points,
                })
            }
        }
    }


    resetDingTimer() {
        clearInterval(this.state.dingTimer);
        this.setState(
            {
                dingTimer: null,
                interval: 0
            })
    }

    beep() {
        var snd = new Audio("data:audio/wav;base64,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");
        snd.play();
    }

    ding() {
        this.beep();
        this.setState(
            {
                dingTimer: setInterval(
                    this.resetDingTimer, 2000),
                interval: 2000
            })
    }

    resetStepTimer() {
        clearInterval(this.state.stepTimer);
        this.setState(
            {
                stepTimer: null,
                interval: 0
            })
    }


    step() {
        clearInterval(this.state.stepTimer);
        this.setState(
            {
                stepTimer: setInterval(
                    this.resetStepTimer, 2522),
                interval: 4000
            })
    }


    getStyles = (ref) => {
        if (!ref) {
            return;
        }
        const rgbToHex = (r, g, b) => '#' + [r, g, b]
            .map(x => x.toString(16).padStart(2, '0')).join('');

        const computed = window.getComputedStyle(ref);
        const brandValue = rgbToHex(...computed.getPropertyValue("--brand-value-color").split(',').map(v => parseInt(v, 10)));
        const personalValue = rgbToHex(...computed.getPropertyValue("--personal-value-color").split(',').map(v => parseInt(v, 10)));
        const inclusion = rgbToHex(...computed.getPropertyValue("--inclusion-color").split(',').map(v => parseInt(v, 10)));
        const affinity = rgbToHex(...computed.getPropertyValue("--affinity-color").split(',').map(v => parseInt(v, 10)));

        this.setState({
            brandvalue: brandValue,
            personalValue: personalValue,
            inclusion: inclusion,
            affinity: affinity
        })
    };

    render() {
        const experience = this.props.experience;

        const level = experience.value;
        if (!level > 0) {
            return <></>
        }

        const start = experience.current_level.xp_base;
        const end = experience.current_level.xp_threshold;
        const currentXP = experience.points;

        const range = (end - start);
        const pointer = (range - (end - currentXP));
        const now = (pointer / range * 100);

        const label = `LV ${experience.value.toString()} | XP ${(currentXP - start).toString()}`;


        if (!this.state.inclusion) {
            return <div className={'inclusion'}
                        ref={ref => this.getStyles(ref)}/>
        }

        let fxProps = {
            x: 100,
            y: -100,
            count: 1,
            interval: this.state.interval,
            colors: [this.state.brandvalue, this.state.personalvalue, this.state.inclusion, this.state.affinity],
        };
        let fxPropsDing1 = {
            x: 200,
            y: -500,
            count: 1,
            interval: this.state.interval,
            colors: [this.state.brandvalue, this.state.personalvalue, this.state.inclusion, this.state.affinity],
        };
        let fxPropsDing2 = {
            x: 600,
            y: -600,
            count: 1,
            interval: this.state.interval,
            colors: [this.state.brandvalue, this.state.personalvalue, this.state.inclusion, this.state.affinity],
        };
        let fxPropsDing3 = {
            x: 300,
            y: -800,
            count: 1,
            interval: this.state.interval,
            colors: [this.state.brandvalue, this.state.personalvalue, this.state.inclusion, this.state.affinity],
        };
        let fxPropsDing4 = {
            x: 1000,
            y: -1000,
            count: 1,
            interval: this.state.interval,
            colors: [this.state.brandvalue, this.state.personalvalue, this.state.inclusion, this.state.affinity],
        };

        return <>
            {this.state.dingTimer &&<>
            <Fireworks {...fxProps} />
            <Fireworks {...fxPropsDing1} />
            <Fireworks {...fxPropsDing2} />
            <Fireworks {...fxPropsDing3} />
            <Fireworks {...fxPropsDing4} />
            </>
            }
            {this.state.stepTimer &&
            <Fireworks {...fxProps} />}
            <Row style={{width: '100%'}}>
            {/*<Col md="auto" style={{paddingRight: '0rem'}}>{start}</Col>*/}
            <Col style={{padding: '0rem', verticalAlign: 'middle'}}>
                <div className="progress"
                     style={{height: '100%'}}>
                    <div className="progress-bar"
                         role="progressbar"
                         style={{width: now + '%'}}
                         aria-valuenow={now}
                         aria-valuemin="0"
                         aria-valuemax="100"
                    >
                        {label}
                    </div>
                </div>
            </Col>
            <div className={'col-md-auto d-none d-md-flex'} style={{width: 'auto', paddingLeft: '0rem'}}>{end - start}</div>
        </Row></>
    }
}
